import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-url-rendered',
  templateUrl: './url-rendered.component.html',
  styleUrls: ['./url-rendered.component.css']
})
export class UrlRenderedComponent extends ElementComponent {
  @Input() override data: any = {
    text: '',
    href: 'http://'
  }
}
